<template>
  <div class="tags-widget">
    <div v-if="!loading" class="current-tags">
      <span class="label label-info" v-for="tag in pickedTags">{{ tag.name }} <button v-if="!readOnly" @click="removeTag(tag.id)"><i class="fa fa-close"></i></button></span>
      <span v-if="!tags.length && renderEmpty"><i>no tags</i></span>
    </div>
    <div v-if="!readOnly" class="dropdown" :class="{open: showTagsMenu}">
      <span class="label label-add">
        <button class="dropdown-toggle" type="button" data-toggle="dropdown" @click="showTagsMenu = !showTagsMenu">
          <i v-if="!showTagsMenu" class="fa fa-lg fa-plus"></i>
          <i v-else class="fa fa-lg fa-close"></i>
        </button>
      </span>
      <ul class="dropdown-menu">
        <li><FormulateInput type="search"  @input="fetchTags" v-model="query" :error="searchError"></FormulateInput></li>
        <li class="divider"></li>
        <li class="pre-scrollable">
          <ul v-if="availableTags.length" class="list-unstyled">
            <li v-for="tagOption in availableTags" :key="tagOption.id">
              <a role="button" class="label label-info" @click="addTag(tagOption)">{{ tagOption.name }}</a>
            </li>
          </ul>
          <div v-else>
            <i>empty</i>
          </div>
        </li>
        <li class="divider"></li>
        <li><FormulateInput :disabled="!query" type="button" @click="createTag">Create <span v-if="query">&nbsp;"{{ query }}" tag</span></FormulateInput></li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      renderEmpty: {
        type: Boolean,
        default: true,
        required: false,
      },
      readOnly: {
        type: Boolean,
        default: false,
        required: false
      },
      tags: Array,
      tagsDb: {
        type: Object,
        default: null,
        required: false
      }
    },
    data () {
      return {
        showTagsMenu: false,
        query: "",
        tagOptions: [],
        errors: null,
        db: {},
        loading: true
      }
    },
    created() {
      this.loading = true;
      this.populateDb();
      this.loading = false;
    },
    computed: {
      tagIds() {
        return this.tags.map((t) => t.hasOwnProperty('id') ? t.id : t);
      },
      tagsSet() {
        return new Set(this.tagIds);
      },
      pickedTags() {
        return this.tagOptions.filter(t => this.tagsSet.has(t.id));
      },
      availableTags() {
        return this.tagOptions.filter(x => !this.tagsSet.has(x.id));
      },
      searchError() {
        try {
          return this.errors.name.join(' ')
        } catch (e) {
          return null;
        }
      }
    },
    watch: {
      showTagsMenu: {
        handler: function (val, old) {
          if (val) {
            this.query = "";
            this.errors = null;
            this.fetchTags()
          }
        }
      }
    },
    mounted () {
    },
    methods: {
      createTag() {
        var self = this;
        API.tags.createByName(self.query)
           .then(
             (res) =>  {
               this.$emit('addTag', res.data);
               self.query = '';
             },
             (error) => {
               this.errors = error.data;
             }
           );
      },
      async populateDb() {
        if (this.tagsDb) {
          this.tagOptions = Object.values(this.tagsDb);
          this.db = this.tagsDb;
        }
        else {
          const res = await API.tags.getList();
          this.tagOptions = res.data.results;
          this.db = Object.fromEntries( res.data.results.map(t => [t.id, t]) );
        }
      },
      fetchTags: _.debounce(async function() {
        var self = this;
        let query = self.query || null;
        const res = await API.tags.getList(query);
        this.tagOptions = res.data.results;
      }, 100),
      removeTag(tag) {
        this.$emit('removeTag', tag);
      },
      addTag(tag) {
        this.$emit('addTag', tag.id);
      }
    }
  }
</script>
<style scoped>
  .current-tags {
    display: flex;
    gap: .25rem;
  }
  .pre-scrollable {
    padding: .5rem;
  }

  .pre-scrollable .list-unstyled li {
    line-height: 3rem;
 }
</style>



// WEBPACK FOOTER //
// TagsWidget.vue?5743a376